import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";

export function validateCreateOtpField(data) {
    const requiredFields = ['aggrId', 'aggrName', 'corpId','method', 'userId', 'urn', 'uniqueId', 'amount'];
    const missingFields = requiredFields.filter(field => {
      const value = data[field];
      return value === undefined || value === null || value === '';
    });
    if (missingFields.length > 0) {
      return {
        isValid: false,
        message: `Missing required field : ${missingFields.join(', ')}`
      };
    }
    return {
      isValid: true,
      message: ''
    };
  }

  export function validateTranscationOtpField(data) {
    const requiredFields = ['aggrId', 'aggrName', 'corpId', 'userId', 'urn','method', 'payeeName','uniqueId', 'amount', 'debitAcc', 'creditAcc', 'creditIfsc', 'otp', 'remarks'];
    const missingFields = requiredFields.filter(field => {
        const value = data[field];
        return value === undefined || value === null || value === '';
    });

    if (missingFields.length > 0) {
        return {
            isValid: false,
            message: `Missing required field(s): ${missingFields.join(', ')}`
        };
    }

    if (data.otp.length !== 6 || !/^\d{6}$/.test(data.otp)) {
        return {
            isValid: false,
            message: 'OTP must be a 6-digit number.'
        };
    }

    if (!data.remarks || data.remarks.trim() === '') {
        return {
            isValid: false,
            message: 'Remarks are required.'
        };
    }

    return {
        isValid: true,
        message: ''
    };
}
export const validateAmount = (amount,limits) => {
  const remainingDailyOverall = limits?.overall?.remainingDaily || 0;
  const remainingMonthlyOverall = limits?.overall?.remainingMonthly || 0;

  const remainingDailyModule = limits?.module?.remainingDaily || 0;
  const remainingMonthlyModule = limits?.module?.remainingMonthly || 0;
  
  const overallSts = limits?.overall?.sts;
  const moduleSts = limits?.module?.sts;

 // Check overall status first
 if (overallSts) {
    if (amount > remainingMonthlyOverall) {
      return { isValid: false, message: `Exceeds overall monthly limit of ${formatAmountIndianRupees(remainingMonthlyOverall)}.` };
    }
    else if(amount > remainingDailyOverall) {
      return { isValid: false, message: `Exceeds overall daily limit of ${formatAmountIndianRupees(remainingDailyOverall)}.` };
    }
}
// Check module status only if it's true
if (moduleSts) {
    if (amount > remainingMonthlyModule) {
      return { isValid: false, message: `Exceeds module monthly limit of ${formatAmountIndianRupees(remainingMonthlyModule)}.` };
    }
    else if (amount > remainingDailyModule) {
      return { isValid: false, message: `Exceeds module daily limit of ${formatAmountIndianRupees(remainingDailyModule)}.` };
    }
}
return { isValid: true };
};
